import React from 'react';

/** Renders a line break element */
const LineBreak = props => <br {...props} />;

export default LineBreak;
